import type { AuditLog } from '@/types/composition-functions';

export interface OperationsFeedIcon {
  bg: string;
  text: string;
  icon: string;
}

/**
 * The dashboard's "Daily Operations" row title. `event` is the stored name or
 * code ("admission_letter.issued"); `event_label` is how the backend says to
 * show it ("Admission Letter Issued").
 */
export function operationsFeedTitle(log: Pick<AuditLog, 'event' | 'event_label'>): string {
  return log.event_label || log.event || 'Activity';
}

const ICON_RULES: ReadonlyArray<{ test: RegExp; icon: OperationsFeedIcon }> = [
  // Before "student", so "Student Password Reset By Admin" reads as a sign-in matter.
  { test: /\blogin\b|password/i, icon: { bg: 'bg-gray-50', text: 'text-gray-600', icon: 'pi-lock' } },
  { test: /fee|payment|bill/i, icon: { bg: 'bg-primary/10', text: 'text-primary', icon: 'pi-wallet' } },
  { test: /student|registration/i, icon: { bg: 'bg-purple-50', text: 'text-purple-600', icon: 'pi-user-plus' } },
  { test: /delete|remove/i, icon: { bg: 'bg-red-50', text: 'text-red-500', icon: 'pi-trash' } },
  { test: /sms|broadcast/i, icon: { bg: 'bg-yellow-50', text: 'text-yellow-600', icon: 'pi-megaphone' } },
  { test: /\b(admission|application|applications|form)\b/i, icon: { bg: 'bg-sky-50', text: 'text-sky-600', icon: 'pi-file' } },
  { test: /\bAI\b/, icon: { bg: 'bg-indigo-50', text: 'text-indigo-600', icon: 'pi-sparkles' } },
  { test: /update|edit|change/i, icon: { bg: 'bg-primary/10', text: 'text-primary', icon: 'pi-pencil' } },
];

const DEFAULT_ICON: OperationsFeedIcon = { bg: 'bg-gray-50', text: 'text-gray-500', icon: 'pi-bell' };

/** The row's icon, from its title. The first matching rule wins. */
export function operationsFeedIcon(title: string | null | undefined): OperationsFeedIcon {
  const value = title ?? '';
  return ICON_RULES.find((rule) => rule.test.test(value))?.icon ?? DEFAULT_ICON;
}
